/**
 * Tarihi görüntüleme formatına çevirir
 * @param {string} dateString - ISO formatında tarih string'i (YYYY-MM-DD)
 * @returns {string} Formatlanmış tarih (DD.MM.YYYY)
 */
export const formatDateToDisplay = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
}; 